import { getRouteApi } from '@tanstack/react-router';

export const productsRouteApi = getRouteApi(
    '/_authenticated/$currentEnterpriseId/Settings/Services/$serviceId/Products'
);
